import { render, staticRenderFns } from "./trending-giveaways.vue?vue&type=template&id=11d9d292&"
import script from "./trending-giveaways.vue?vue&type=script&lang=js&"
export * from "./trending-giveaways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports